export { default } from './LearnMore';



// WEBPACK FOOTER //
// ./src/components/templates/LearnMore/index.js